import { Injectable } from '@angular/core';
import { States } from '../../shared';

@Injectable()
export class RedirectFromOldAppService {
  private readonly oldToNewUrlMapping: Array<[RegExp, string]> = [
    [new RegExp('/index/.*/agentAccountActivation/(.*)'), `${States.Agent}/${States.AccountActivation}/[1]`],
    [
      new RegExp('/index/.*/caseOverview/(.*)/caseMessaging'),
      `${States.BrokerCaseOverview}/[1]/${States.BrokerCaseMessaging}`
    ],
    [
      new RegExp('/index/.*/caseOverview/(.*)/casePackagingActions'),
      `${States.BrokerCaseOverview}/[1]/${States.BrokerCasePackagingActions}`
    ],
    [
      new RegExp('/index/.*/directCustomerAccountActivation/(.*)'),
      `${States.DirectActivation}/${States.AccountActivation}/[1]`
    ],
    [new RegExp('/index/.*/virtualOffice/caseMessaging/(.*)'), `${States.CustomerHub}/[1]/${States.CustomerMessaging}`],
    [
      new RegExp('/index/.*/virtualOffice/customerPackagingActions/(.*)'),
      `${States.CustomerHub}/[1]/${States.CustomerCasePackagingActions}`
    ],
    [
      new RegExp('/index/.*/authenticateOffer/(.*)/(.*)'),
      `${States.OnlineOffer}/${States.AuthenticateOffer}?id=[1]&isNewBusiness=[2]`
    ],
    [
      new RegExp('/index/.*/sendOfferAccessCode/(.*)/(.*)'),
      `${States.OnlineOffer}/${States.SendOfferAccessCode}?id=[1]&isNewBusiness=[2]`
    ],
    [new RegExp('/index/.*/resetForgottenPassword/(.*)'), `${States.ResetForgottenPassword}/[1]`],
    [new RegExp('/index/.*/onlineAdvised'), `${States.Advised}/${States.AdvisedLandingPage}`],
    [new RegExp('/index/.*/residential'), `${States.NonAdvised}/${States.Residential}`],
    [new RegExp('/index/.*/buyToLet'), `${States.NonAdvised}/${States.BuyToLet}`],
    [new RegExp('/index/.*/agentRegistration'), `${States.Agent}/${States.AgentRegistration}`],
    [new RegExp('/index/.*/register'), `${States.Customer}/${States.ExistingCustomerRegistration}`],
    [new RegExp('/index/.*/makePayment/(.*)'), `${States.MakePayment}/[1]`]
  ];

  public mapOldUrlToNew(oldUrlFragment: string): string {
    for (const urlMappingEntry of this.oldToNewUrlMapping) {
      const matchResult = oldUrlFragment.match(urlMappingEntry[0]);

      if (matchResult) {
        let newUrlEnding = urlMappingEntry[1];

        for (let index = 1; index < matchResult.length; index++) {
          newUrlEnding = newUrlEnding.replace(`[${index}]`, matchResult[index]);
        }

        return newUrlEnding;
      }
    }

    return States.Login;
  }
}
